var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"water-mark-mask"},_vm._l((7),function(i){return _c('div',{staticClass:"row"},_vm._l((3),function(i){return _c('div',{staticClass:"col",style:({ color: _vm.color })},[_c('span',[_vm._v(_vm._s(_vm.info))])])}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-559363bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Watermark.vue
// module id = null
// module chunks = 